module.exports = __webpack_public_path__ + "img/yi.2954e4af.svg";